type ExternalFlaggable = {
  external?: boolean | null;
  externalTablespace?: string | null;
};

type PracticeLike = ExternalFlaggable;

type ProviderLike = ExternalFlaggable & {
  relatedPractices?: PracticeLike[] | null;
};

export const isExternalMarket = (
  market?: ExternalFlaggable | null
): boolean => {
  return market?.external === true;
};

export const isExternalPractice = (
  practice?: PracticeLike | null
): boolean => {
  return practice?.external === true;
};

export const isExternalProvider = (
  provider?: ProviderLike | null
): boolean => {
  if (!provider) return false;

  if (provider.external === true) return true;

  const relatedPractices = provider.relatedPractices || [];
  if (relatedPractices.length > 0) {
    return relatedPractices.every((practice) =>
      isExternalPractice(practice)
    );
  }

  return false;
};

export const applyExternalFilterForNonAdmin = <
  T extends Record<string, string | string[] | undefined>
>(
  filters: T,
  isAdmin: boolean
): T & { includeExternal: string } => {
  return {
    ...filters,
    includeExternal: isAdmin ? 'true' : 'false',
  };
};
